export default "__VITE_ASSET__BS5_TUe7__"